function LabelAndValue({label, value}) {
    return (
        <div className="label-value" style={{
          display:"flex",
          flexDirection: "column",
          alignItems:"center",
          justifyContent:"space-between",
          fontSize: "14px"
        }}>
            <p >{label}</p>
            <p style={{fontWeight:"bold", fontSize: "18px"}}>{value}</p>    
        </div>
    )
}

export default LabelAndValue;